/**
 * L2-R5: moved to @miq/utils (lib/uom-calculator/*). This shim keeps the old barrel import
 * path working; new code should import from '@miq/utils'.
 */
export type { AmountObject, ReduceOptionInterface } from '@miq/utils';
export { findUnit, getSafeUnit, getUnit, getUnitsOf, makeAmountWith, makeAmount, makeAmountObject, amountAs } from '@miq/utils';
export { addition, subtract, reduceAmountWith, average, averageOfDataset, calcPercentage } from '@miq/utils';
export { Squared, SquaredKilometer, SquareMile, Hectare, Acre, ZERO_SF, ZERO_SM, UOM_UNIT_MAP, UOMS } from '@miq/utils';
